import { ENV_DEMO, ENV_DEV, ENV_LIVE, ENV_TEST, ENV_PRE_LIVE } from "./Constants";

const environments = {
    localhost: {
        cryptoMainUrlV1: "https://api.cryptofacil.io/api/v1",
        mainUrl: "https://middle-test.pfserver.net/PFManagementServices/api/v1/",
        checkoutReceiptUrl: "https://checkout.pfserver.net/pf/default-receipt/",
        widgetUrl: "https://sdk.pfserver.net/widgetapp/?session={session}&idActivity={idActivity}&method=CRYPTO&idUsrService={idUsrService}",
        apiKey: "mquUQFP7JjMwwj7vYlZDTKTzrG5HdSTV",
        apiKeyCryptofacil: "6691993b7beaf957731e2915",
        encoded: true,
        encodedCryptofacil: false,
        env: ENV_TEST
    },
    "cryptofacil.pfserver.net": {
        cryptoMainUrlV1: "https://api.cryptofacil.io/api/v1",
        mainUrl: "https://middle-test.pfserver.net/PFManagementServices/api/v1/",
        checkoutReceiptUrl: "https://checkout.pfserver.net/pf/default-receipt/",
        widgetUrl: "https://sdk.pfserver.net/widgetapp/?session={session}&idActivity={idActivity}&method=CRYPTO&idUsrService={idUsrService}",
        apiKey: "mquUQFP7JjMwwj7vYlZDTKTzrG5HdSTV",
        apiKeyCryptofacil: "6691993b7beaf957731e2915",
        encoded: true,
        encodedCryptofacil: false,
        env: ENV_DEV
    },
    'app-demo.cryptofacil.io': {
        cryptoMainUrlV1: "https://api.cryptofacil.io/api/v1",
        mainUrl: "https://sandbox.paguelofacil.com/PFManagementServices/api/v1/",
        checkoutReceiptUrl: "https://checkout-demo.paguelofacil.com/pf/default-receipt/",
        widgetUrl: "https://sdk-sand.paguelofacil.com/widgetapp/?session={session}&idActivity={idActivity}&method=CRYPTO&idUsrService={idUsrService}",
        apiKey: "4UXJg6rJT76OOE5OYXV0eHcatm3EXpss",
        apiKeyCryptofacil: "6691993b7beaf957731e2915",
        encoded: true,
        encodedCryptofacil: false,
        env: ENV_DEMO
    },
    "app-pre.cryptofacil.io": {
        cryptoMainUrlV1: "https://api.cryptofacil.io/api/v1",
        mainUrl: "https://admin.paguelofacil.com/PFManagementServices/api/v1/",
        checkoutReceiptUrl: "https://pre-checkout.pfserver.net/pf/default-receipt/",
        widgetUrl: "https://sdk.paguelofacil.com/widgetapp/?session={session}&idActivity={idActivity}&method=CRYPTO&idUsrService={idUsrService}",
        apiKey: "4UXJg6rJT76OOE5OYXV0eHcatm3EXpss",
        apiKeyCryptofacil: "6691993b7beaf957731e2915",
        encoded: true,
        encodedCryptofacil: false,
        env: ENV_PRE_LIVE
    },
    "app.cryptofacil.io": {
        mainUrl: "https://admin.paguelofacil.com/PFManagementServices/api/v1/",
        cryptoMainUrlV1: "https://api.cryptofacil.io/api/v1",
        checkoutReceiptUrl: "https://checkout.paguelofacil.com/pf/default-receipt/",
        widgetUrl: "https://sdk.paguelofacil.com/widgetapp/?session={session}&idActivity={idActivity}&method=CRYPTO&idUsrService={idUsrService}",
        apiKey: "4UXJg6rJT76OOE5OYXV0eHcatm3EXpss",
        apiKeyCryptofacil: "6691993b7beaf957731e2915",
        encoded: true,
        encodedCryptofacil: false,
        env: ENV_LIVE
    },
};
export const getCurrentEnvironment = () => {
    let env = environments["cryptofacil.paguelofacil.com"];

    if (environments[window.location.host]) {
        env = environments[window.location.host];
    }
    if (environments[window.location.hostname]) {
        env = environments[window.location.hostname];
    }
    return env;
};

if (process.env.NODE_ENV === "production" && ![ENV_DEV, ENV_TEST, ENV_PRE_LIVE].includes(getCurrentEnvironment().env)) {
    console.log = console.warn = console.error = console.info = console.table = () => { };
}